export default "/images/ozon.png?9acb4546f2c843d949aa440e580ca78e";